/**
 * Bit/hole sizes are conventionally written as vulgar fractions (8¾", 6⅛",
 * 12¼"). The stored value is a decimal inch; this renders the driller-facing
 * fraction. Only the common 32nd-step drilling sizes are mapped; anything else
 * falls back to a trimmed decimal.
 */
const FRAC: Record<string, string> = {
  "0.125": "⅛",
  "0.25": "¼",
  "0.375": "⅜",
  "0.5": "½",
  "0.625": "⅝",
  "0.75": "¾",
  "0.875": "⅞",
};

/** "8.75" | 8.75 → `8¾″`. Null/blank → em dash. */
export function inchFrac(size: number | string | null | undefined): string {
  if (size == null || size === "") return "—";
  const n = typeof size === "string" ? Number(size) : size;
  if (!Number.isFinite(n)) return String(size);
  const whole = Math.floor(n);
  const frac = +(n - whole).toFixed(3);
  const fracStr = FRAC[String(frac)];
  if (frac === 0) return `${whole}″`;
  if (fracStr) return `${whole}${fracStr}″`;
  // Uncommon size — trim trailing zeros off the decimal.
  return `${n}″`;
}
